module.exports = __webpack_public_path__ + "0d199b90b58aca3b26a738d1a4948561.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/prenatal-card-hero.jpg
// module id = 414
// module chunks = 1